import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { partners } from '../../data/partnersData';
import './Partners.css';

const Partners: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <section className="partners-section">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">{t('home.partners.title', 'Nos Partners')}</h2>
          <p className="section-subtitle">{t('home.partners.subtitle', 'Approuvé par les leaders de l\'industrie à travers le Maroc')}</p>
        </motion.div>
        
        <div className="partners-grid">
          {partners.map((partner, index) => (
            <motion.div
              className="partner-item"
              key={partner.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="partner-logo">
                {partner.url ? (
                  <a href={partner.url} target="_blank" rel="noopener noreferrer" title={partner.name}>
                    <img 
                      src={partner.image} 
                      alt={partner.name} 
                      title={partner.name}
                    />
                  </a>
                ) : (
                  <img 
                    src={partner.image} 
                    alt={partner.name} 
                    title={partner.name}
                  />
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;
